import styled, { css } from 'styled-components';
import { minBp, theme, Button, FormFieldInput } from '@triumph/shared';
import _ChevronDown from 'src/assets/icons/chevron-down.svg';

export const Wrap = styled.div`
  padding: 55px 30px 30px;

  @media ${minBp('tablet')} {
    padding: 75px 60px 60px;
    width: 650px;
  }

  @media ${minBp('tabletLarge')} {
    width: 800px;
  }
`;

export const H4 = styled.h4`
  text-transform: uppercase;
  margin-bottom: 7px;
`;

export const Tagline = styled.p`
  margin-bottom: 15px;
`;

export const Input = styled(FormFieldInput)`
  display: block;
  margin-bottom: 15px;
  width: 100%;

  @media ${minBp('tabletLarge')} {
    width: 530px;
  }
`;

export const Buttons = styled.div`
  display: flex;
`;

export const sharedButtonStyles = css`
  display: inline-block;

  @media ${minBp('tabletLarge')} {
    width: 200px;
  }
`;

export const PrimaryButton = styled(Button)`
  ${sharedButtonStyles}
  margin-right: 15px;
`;

export const SecondaryButton = styled(Button)`
  ${sharedButtonStyles}
  display: inline-block;
`;

export const InputError = styled.div`
  ${({ theme }) => `
    color: ${theme.colors.primary};
    font-weight: 500;
    font-size: 14px;
    font-family: ${({ theme }) => theme.fonts.dinDemi};
    margin-top: 8px;
    margin-bottom: 15px;
  `}
`;

export const Radios = styled.div`
  margin-bottom: 25px;

  @media ${minBp('desktop')} {
    margin-bottom: 15px;
  }
`;

export const Checkboxes = styled.div`
  margin-bottom: 35px;

  @media ${minBp('tablet')} {
    margin-top: 10px;
    margin-bottom: 0;
  }
`;

export const CheckboxWrapper = styled.div`
  margin: 0 0 18px;
  font-size: 14px;
  color: #000;
`;

export const SharedTextStyles = css`
  color: #000;
  font-size: 14px;
`;

export const Text = styled.p`
  ${SharedTextStyles}
  margin-bottom: 8px;
`;

export const ContentToggle = styled.span`
  ${SharedTextStyles}
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-bottom: 6px;

  ${({ isActive }) => `
    ${ChevronDown} {
      transform: ${isActive ? 'rotate(180deg)' : 'rotate(0)'};
    }
  `}
`;

export const ChevronDown = styled(_ChevronDown)`
  margin: 4px;
  width: 12px;
  height: 12px;

  path {
    ${({ theme }) => `
      fill: ${theme.colors.primary};
    `}
  }
`;

export const AdditionalContent = styled.p`
  ${SharedTextStyles}

  ${({ isActive }) => `
    display: ${isActive ? 'block' : 'none'};
  `}
`;

export const SuccessMessage = styled.span`
  ${({ theme }) => `
    color: ${theme.colors.heading};
  `}
`;
